import { useEffect } from "react";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { EventType, InteractionStatus } from "@azure/msal-browser";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { PageLayout } from "../components/PageLayout";
import { compareIssuingPolicy } from "../utils/claimUtils";
import SignUp from "../pages/authentication/components/SignUp";
import UseAuthConfig from "../hooks/useAuthConfig";
import { getRoutesForInactiveOrganisation, getRoutesForRole } from "./RoleRoutes";
import {
  OrganisationStatusProvider,
  useOrganisationStatus,
} from "../context/organisationStatus";
import { UserRole } from "../utils";
import LoaderHome from "../components/atoms/Loader-home/Loader-home";
import Loader from "../components/atoms/Loader/Loader";

const Pages = () => {
  // const { b2cPolicies } = UseAuthConfig();
  // const navigate = useNavigate();
  // const location = useLocation();
  // const { instance, accounts } = useMsal();
  // const userRole = accounts[0]?.idTokenClaims?.extension_ilpr;

  // // useEffect(() => {
  // //     if (userRole === UserRole.Operator && location.pathname !== "/new-lead") {
  // //       navigate("/new-lead", { replace: true });
  // //     }
  // //   }, [userRole, location.pathname, navigate]);

  // useEffect(() => {
  //     const callbackId = instance.addEventCallback((event) => {
  //         if (
  //             event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS &&
  //             event.payload?.account &&
  //             compareIssuingPolicy(event.payload.idTokenClaims, b2cPolicies.names.editProfile)
  //         ) {
  //             const originalSignInAccount = instance
  //                 .getAllAccounts()
  //                 .find(
  //                     (account) =>
  //                         account.idTokenClaims.oid === event.payload.idTokenClaims.oid &&
  //                         account.idTokenClaims.sub === event.payload.idTokenClaims.sub &&
  //                         compareIssuingPolicy(account.idTokenClaims, b2cPolicies.names.signUpSignIn)
  //                 );

  //             let signUpSignInFlowRequest = {
  //                 authority: b2cPolicies.authorities.signUpSignIn.authority,
  //                 account: originalSignInAccount,
  //             };

  //             instance.ssoSilent(signUpSignInFlowRequest);
  //         }

  //         if (
  //             event.eventType === EventType.LOGIN_FAILURE &&
  //             event.error?.errorMessage.includes('AADB2C90118')
  //         ) {
  //             const resetPasswordRequest = {
  //                 authority: b2cPolicies.authorities.forgotPassword.authority,
  //                 scopes: [],
  //             };
  //             instance.loginRedirect(resetPasswordRequest);
  //         }
  //     });

  //     return () => {
  //         if (callbackId) {
  //             instance.removeEventCallback(callbackId);
  //         }
  //     };
  // }, [instance, navigate, b2cPolicies]);

  // return (
  //     <Routes>
  //         {getRoutesForRole(userRole)}
  //         <Route path="/signup" element={<SignUp />} />
  //     </Routes>
  // );

  const { instance, accounts, inProgress } = useMsal();
  const { loginRequest } = UseAuthConfig();

  const isAuthenticated = accounts.length > 0;
  const userRole = accounts[0]?.idTokenClaims?.extension_ilpr;
  const {
    isOrganisationActive,
    isLoading: isOrganisationStatusLoading,
  } = useOrganisationStatus();

  // 🔥 THIS is the important part
  useEffect(() => {
    if (inProgress === InteractionStatus.None && !isAuthenticated) {
      instance.loginRedirect(loginRequest);
    }
  }, [inProgress, isAuthenticated, instance, loginRequest]);

  if (inProgress !== InteractionStatus.None) {
    return (
      <div>
        <LoaderHome />
        <LoaderHome />
        <LoaderHome />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <div>Redirecting to login...</div>;
  }

  if (isOrganisationStatusLoading) {
    return <Loader />;
  }

  return (
    <Routes>
      {isOrganisationActive
        ? getRoutesForRole(userRole)
        : getRoutesForInactiveOrganisation()}
      <Route path="/signup" element={<SignUp />} />
    </Routes>
  );
};

const App = ({ instance }) => {
  return (
    <MsalProvider instance={instance}>
      <OrganisationStatusProvider>
        <PageLayout>
          <Pages />
        </PageLayout>
      </OrganisationStatusProvider>
    </MsalProvider>
  );
};

export default App;
